<template>
  <div>
    <!-- 全民分销 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>活动管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
      <el-breadcrumb-item>活动详情</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="titleBox">
      <div class="tab">
        <span
          v-for="(v,i) in tabBtn"
          :key="v.id"
          @click="tabTitle(i)"
          :class="activeIndex==i?'activeTab':''"
        >{{v.name}}</span>
      </div>
      <div class="switchTitle" v-if="activeIndex==0">
        <span>开通个人分销活动</span>
        <el-switch v-model="value" active-color="#246DEB" inactive-color="#D9D9D9"></el-switch>
      </div>
    </div>

    <div v-if="activeIndex==0">
      <el-card>
        <div class="hearderBox">
          <el-input placeholder="请输入内容" v-model="input" clearable></el-input>
          <el-input placeholder="请输入内容" v-model="input" clearable></el-input>
          <el-select v-model="value" clearable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button>查询</el-button>
        </div>
        <div>
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColorLeft"
            :cell-style="cellStyleLeft"
            style="width: 100%"
            key="one"
          >
            <el-table-column prop="date" label="ID"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="address" label="级别"></el-table-column>
            <el-table-column prop="address" label="邀请人"></el-table-column>
            <el-table-column prop="address" label="注册时间"></el-table-column>
            <el-table-column prop="address" label="联系方式"></el-table-column>
            <el-table-column prop="address" label="邀请人数"></el-table-column>
            <el-table-column prop="address" label="自推订单"></el-table-column>
            <el-table-column prop="address" label="自推收入"></el-table-column>
            <el-table-column prop="address" label="管理佣金"></el-table-column>
            <el-table-column prop="address" label="总收入"></el-table-column>
            <el-table-column prop="address" label="操作">
              <template slot-scope="scope">
                <el-button type="text" style="color: #E74C3C;">封号</el-button>
                <el-button type="text" @click="infoFn(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-card>
    </div>
    <div v-if="activeIndex==1">
      <el-card style="height:740px">
        <div class="distributionBox">
          <el-form ref="form" :model="form" label-width="130px">
            <el-form-item>
              <el-radio-group v-model="form.classRadio" @change="classRadioFn">
                <el-radio label="1">统一设置</el-radio>
                <el-radio label="2">单独设置</el-radio>
              </el-radio-group>
            </el-form-item>
            <div v-if="radioClass==1">
              <div class="itemOne">
                <el-form-item label="自推佣金比例:">
                  <span class="xingA">*</span>
                  <el-input v-model="form.name">
                    <template>
                      <slot slot="suffix" class="input-slot">%</slot>
                    </template>
                  </el-input>
                  <div class="zhu">
                    <span>注:</span>
                    <span>
                      自推佣金比例是每卖出一分产品可得产品销售价格的百分比,如某产品100元,
                      自推佣金比列是3%,那么可得佣金是3元
                    </span>
                  </div>
                </el-form-item>
                <el-form-item label="管理佣金比例:">
                  <span class="xingA">*</span>
                  <el-input v-model="form.name">
                    <template>
                      <slot slot="suffix" class="input-slot">%</slot>
                    </template>
                  </el-input>
                  <div class="zhu">
                    <span>注:</span>
                    <span>
                      管理佣金比例是被邀请人每卖出一分产品可得产品销售价格的百分比,
                      如A邀请了B,B卖出某产品100元,管理佣金比例是0.5%,那么A可得佣金是0.5元
                    </span>
                  </div>
                </el-form-item>
              </div>
              <div class="itemTwo">
                <el-form-item label="有效周期:">
                  <span class="xingB">*</span>
                  <el-select v-model="value" clearable placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="设置开启:">
                  <span class="xingB">*</span>
                  <el-radio-group v-model="radio">
                    <el-radio :label="1">线上</el-radio>
                    <el-radio :label="2">线下</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <el-form-item class="itemBtn">
                <el-button>删除</el-button>
                <el-button class="btnL">保存</el-button>
              </el-form-item>
            </div>
            <div v-if="radioClass==2">
              <div class="itemFour">
                <el-form-item label="自推产品名称:">
                  <span class="xingA">*</span>
                  <el-select v-model="value" clearable placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="itemOne">
                <el-form-item label="管理佣金比例:">
                  <span class="xingA">*</span>
                  <el-input v-model="form.name">
                    <template>
                      <slot slot="suffix" class="input-slot">%</slot>
                    </template>
                  </el-input>
                  <div class="zhu">
                    <span>注:</span>
                    <span>
                      管理佣金比例是被邀请人每卖出一分产品可得产品销售价格的百分比,
                      如A邀请了B,B卖出某产品100元,管理佣金比例是0.5%,那么A可得佣金是0.5元
                    </span>
                  </div>
                </el-form-item>
                <el-form-item label="自推佣金比例:">
                  <span class="xingA">*</span>
                  <el-input v-model="form.name">
                    <template>
                      <slot slot="suffix" class="input-slot">%</slot>
                    </template>
                  </el-input>
                  <div class="zhu">
                    <span>注:</span>
                    <span>
                      自推佣金比例是每卖出一分产品可得产品销售价格的百分比,如某产品100元,
                      自推佣金比列是3%,那么可得佣金是3元
                    </span>
                  </div>
                </el-form-item>
              </div>
              <div class="itemTwo">
                <el-form-item label="有效周期:">
                  <span class="xingB">*</span>
                  <el-select v-model="value" clearable placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="设置开启:">
                  <span class="xingB">*</span>
                  <el-radio-group v-model="radio">
                    <el-radio :label="1">线上</el-radio>
                    <el-radio :label="2">线下</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>

              <el-form-item class="itemBtnS">
                <el-button>删除</el-button>
                <el-button class="btnL">保存</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="aloneBox" v-if="radioClass==2">
          <div>
            <el-table
              :data="tableData"
              :header-cell-style="tableHeaderColorLeft"
              :cell-style="cellStyleLeft"
              style="width: 100%"
              key="two"
            >
              <el-table-column prop="date" label="产品名称"></el-table-column>
              <el-table-column prop="name" label="有效周期"></el-table-column>
              <el-table-column prop="address" label="自推佣金比例"></el-table-column>
              <el-table-column prop="address" label="管理佣金比例"></el-table-column>
              <el-table-column prop="address" label="状态">
                <template slot-scope="scope">
                  <img src="@/images/scenic/dh.png" alt />
                  <img src="@/images/scenic/dl.png" alt />
                  <span style="margin-left:10px">{{scope.row.address}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" style="color: #E74C3C;">删除</el-button>
                  <el-button type="text">编辑</el-button>
                  <el-button type="text">下载</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页开始 -->
          <div class="pagination">
            <span class="demonstration">共几条记录，</span>
            <span class="demonstration">当前显示第几页</span>
            <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
          </div>
          <!-- 分页结束 -->
        </div>
      </el-card>
    </div>
    <div v-if="activeIndex==2">
      <div class="redBox">
        <div class="redBoxForm">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="红包名称:">
              <span class="xingA">*</span>
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="红包类型:">
              <span class="xingA">*</span>
              <el-select v-model="value" clearable placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="有效周期:">
              <span class="xingA">*</span>
              <el-select v-model="value" clearable placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="红包金额:">
              <span class="xingA">*</span>
              <el-input v-model="form.name" placeholder="请输入">
                <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="红包数量:">
              <span class="xingA">*</span>
              <el-input v-model="form.name" placeholder="请输入">
                <template>
                  <slot slot="suffix" class="input-slot">个</slot>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="最低门槛:">
              <span class="xingA">*</span>
              <el-input v-model="form.name" placeholder="请输入">
                <template>
                  <slot slot="suffix" class="input-slot">元</slot>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="使用设置:">
              <span class="xingA">*</span>
              <el-select v-model="value" clearable placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设置开启:">
              <span class="xingA">*</span>
              <el-radio-group v-model="radio">
                <el-radio :label="1">线上</el-radio>
                <el-radio :label="2">线下</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item class="itemBtn">
              <el-button>删除</el-button>
              <el-button class="btnL">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div v-if="activeIndex==3">
      <el-card style="height:740px">
        <div class="distributionBox">
          <el-form ref="form" :model="form" label-width="130px">
            <el-form-item>
              <el-radio-group v-model="form.classRadio" @change="classRadioFn">
                <el-radio label="1">统一设置</el-radio>
                <el-radio label="2">单独设置</el-radio>
              </el-radio-group>
            </el-form-item>
            <div v-if="radioClass==1">
              <div class="itemOne">
                <el-form-item label="佣金发放状态:">
                  <span class="xingA">*</span>
                  <el-select v-model="value" clearable placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <div class="zhu">
                    <span style="margin-right:10px">例:</span>
                    <span>通过个人分销商购买的滑雪票,在线下核销后才会给个人分销商预支佣金,此时不可随时提取</span>
                  </div>
                </el-form-item>
                <el-form-item label="佣金发放时间:">
                  <span class="xingA">*</span>
                  <el-select v-model="value" clearable placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <div class="zhu">
                    <span style="margin-right:10px">注:</span>
                    <span>发放时间是指状态后所延时的时间</span>
                  </div>
                </el-form-item>
              </div>
              <div class="itemTwo">
                <el-form-item label="提现日期:">
                  <span class="xingB">*</span>
                  <el-select v-model="value" clearable placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <div class="zhu">
                    <span style="margin-right:10px">注:</span>
                    <span>每月固定日期,提现前一个月产生的分销佣金</span>
                  </div>
                </el-form-item>
                <el-form-item label="设开启手动审核:">
                  <span class="xingC">*</span>
                  <el-radio-group v-model="radio">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="2">关闭</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <el-form-item class="itemBtnS">
                <el-button>删除</el-button>
                <el-button class="btnL">保存</el-button>
              </el-form-item>
            </div>
            <div v-if="radioClass==2">
              <div class="itemOne">
                <el-form-item label="佣金发放状态:">
                  <span class="xingA">*</span>
                  <el-select v-model="value" clearable placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <div class="zhu">
                    <span style="margin-right:10px">例:</span>
                    <span>通过个人分销商购买的滑雪票,在线下核销后才会给个人分销商预支佣金,此时不可随时提取</span>
                  </div>
                </el-form-item>
                <el-form-item label="佣金发放时间:">
                  <span class="xingA">*</span>
                  <el-select v-model="value" clearable placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <div class="zhu">
                    <span style="margin-right:10px">注:</span>
                    <span>发放时间是指状态后所延时的时间</span>
                  </div>
                </el-form-item>
              </div>
              <div class="itemTwo">
                <el-form-item label="提现日期:">
                  <span class="xingB">*</span>
                  <el-select v-model="value" clearable placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <div class="zhu">
                    <span style="margin-right:10px">注:</span>
                    <span>每月固定日期,提现前一个月产生的分销佣金</span>
                  </div>
                </el-form-item>
                <el-form-item label="设开启手动审核:">
                  <span class="xingC">*</span>
                  <el-radio-group v-model="radio">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="2">关闭</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <el-form-item class="itemBtnS">
                <el-button>删除</el-button>
                <el-button class="btnL">保存</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="aloneBox" v-if="radioClass==2">
          <div>
            <el-table
              :data="tableData"
              :header-cell-style="tableHeaderColorLeft"
              :cell-style="cellStyleLeft"
              style="width: 100%"
              key="two"
            >
              <el-table-column prop="date" label="时间"></el-table-column>
              <el-table-column prop="name" label="ID"></el-table-column>
              <el-table-column prop="address" label="会员名称"></el-table-column>

              <el-table-column prop="address" label="级别">
                <template slot-scope="scope">
                  <img src="@/images/scenic/dh.png" alt />
                  <img src="@/images/scenic/dl.png" alt />
                  <span style="margin-left:10px">{{scope.row.address}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="联系方式"></el-table-column>
              <el-table-column prop="address" label="累计佣金"></el-table-column>
              <el-table-column prop="address" label="已提现金额"></el-table-column>
              <el-table-column prop="address" label="申请金额"></el-table-column>
              <el-table-column prop="address" label="状态">
                <template slot-scope="scope">
                  <img src="@/images/scenic/dh.png" alt />
                  <img src="@/images/scenic/dl.png" alt />
                  <span style="margin-left:10px">{{scope.row.address}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" style="color: #E74C3C;" @click="rejectFn(scope.row,11)">驳回</el-button>
                  <el-button type="text">发放</el-button>
                  <el-button type="text" @click="rejectFn(scope.row,22)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页开始 -->
          <div class="pagination">
            <span class="demonstration">共几条记录，</span>
            <span class="demonstration">当前显示第几页</span>
            <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
          </div>
          <!-- 分页结束 -->
        </div>
      </el-card>
    </div>
    <!-- 会员列表详情开始 -->
    <cardInfoDialog v-if="cardvisible" ref="cardDialog"></cardInfoDialog>
    <!-- 会员列表详情结束 -->
    <!-- 返佣设置驳回开始 -->
    <cardInfoDialog v-if="rejectvisible" ref="rejectDialog"></cardInfoDialog>
    <!-- 返佣设置驳回结束 -->
  </div>
</template>

<script>
import cardInfoDialog from "./dialog/cardInfoDialog.vue";
export default {
  components: {
    cardInfoDialog
  },
  data() {
    return {
      cardvisible: false, // 会员列表详情
      rejectvisible: false, // 返佣设置驳回
      tabBtn: [
        {
          id: 1,
          name: "会员列表"
        },
        {
          id: 2,
          name: "产品分销"
        },
        {
          id: 3,
          name: "新人红包"
        },
        {
          id: 4,
          name: "返佣设置"
        }
      ],
      activeIndex: "",
      value: true,
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      input: "",
      radio: "",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄"
        }
      ],
      form: {
        name: "",
        classRadio: "1"
      },
      radioClass: ""
    };
  },
  mounted() {
    this.radioClass = 1;
  },
  methods: {
    // 返佣设置驳回
    rejectFn(row, num) {
      this.rejectvisible = true;
      this.$nextTick(() => {
        this.$refs.rejectDialog.rejectInfo(row, num);
      });
    },
    // 产品分销单独统一
    classRadioFn(e) {
      // console.log(e);
      this.radioClass = e;
    },
    // 会员列表详情
    infoFn(row) {
      this.cardvisible = true;
      this.$nextTick(() => {
        this.$refs.cardDialog.cardInfo(row);
      });
    },
    tabTitle(index) {
      // console.log(index);
      this.activeIndex = index;
      console.log(this.activeIndex);
    },
    // 文字左对齐表头设置
    tableHeaderColorLeft({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColorLeft({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyleLeft({ row, rowIndex }) {
      return this.utils.cellStyleLeft({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.aloneBox {
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 30px auto 10px;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
}
.redBox {
  width: 100%;
  height: 740px;
  background: #e5e5e5;
  .itemBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: -130px;
    margin-top: 50px;
    .el-button {
      width: 100px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
  }
  .redBoxForm {
    width: 928px;
    // line-height: 740px;
    background: white;
    margin: auto;
    padding: 100px 120px 80px 80px;
    box-sizing: border-box;
    /deep/.el-form-item {
      margin-bottom: 20px;
      position: relative;
    }
    .xingA {
      position: absolute;
      top: 0px;
      left: -78px;
      color: #ff4d4f;
    }
    .el-input,
    .el-select {
      width: 650px;
    }
  }
}
.distributionBox {
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -106px;
    color: #ff3b3b;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -78px;
    color: #ff3b3b;
  }
  .xingC {
    position: absolute;
    top: 0px;
    left: -120px;
    color: #ff3b3b;
  }
  .itemFour {
    .el-select {
      width: 650px;
    }
  }
  .itemBtnS {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: -130px;
    margin-top: 20px;
    .el-button {
      width: 100px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: -130px;
    margin-top: 100px;
    .el-button {
      width: 100px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
  }
  .zhu {
    width: 650px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #ff3b3b;
    margin-top: 8px;
  }
  .itemOne {
    display: flex;
    .el-input,
    .el-select {
      width: 650px;
    }
  }
  .itemTwo {
    display: flex;
    .el-select {
      width: 650px;
    }
  }
}
.hearderBox {
  margin-bottom: 20px;
  .el-input,
  .el-select {
    width: 220px;
    margin-right: 20px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
  }
}
.titleBox {
  display: flex;
  .tab {
    width: 60%;
    display: flex;
    margin: 20px 0;
    .activeTab {
      background: #246deb;
    }
    span {
      width: 120px;
      height: 40px;
      display: block;
      border-radius: 0px 0px 4px 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      color: #ffffff;
      border: none;
      text-align: center;
      background: #d9d9d9;
      margin-right: 20px;
    }
  }
  .switchTitle {
    width: 40%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    > span {
      margin-right: 20px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
</style>